import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronRight } from '@fortawesome/pro-regular-svg-icons/faChevronRight';
import classNames from 'classnames/bind';

import InsiderSvc from '../../../../services/dbServices/InsiderSvc';
import { UK_PRIVATE_COMPANY_INSIGHTS_PATH } from '../../../../data/ukPrivateCompanyInsights';

import Preloader from '../../../Preloader';
import Tooltip from '../../../Tooltip';

import Styles from './styles.module.scss';

const cx = classNames.bind(Styles);

const NatureBusinessSectors = () => {
  const [natureData, setNatureData] = useState({
    loading: true,
    data: [],
  });

  useEffect(() => {
    let mounted = true;

    InsiderSvc.getCompanyInsiderNature()
      .then((data) => {
        if (!mounted) {
          return;
        }

        setNatureData({
          loading: false,
          data: data.slice(0, 6),
        });
      });

    return () => {
      mounted = false;
    };
  }, []);

  return (
    <div className={Styles['nature-business-holder']}>
      <div className={Styles['nature-business-holder-title']}>
        <div className={Styles['nature-business-holder-title-text']}>
          Sectors
          <Tooltip
            newIcon
            hasBigScreenDesign
            isCentered
            dynamicPosition
            contentStyle={{ left: 0 }}
            className={Styles['nature-business-holder-tooltip']}
          >
            Breakdown of nature of business as extracted from filings reported to Companies House.
          </Tooltip>
        </div>
      </div>
      <div
        className={cx('nature-business', {
          min_height: natureData.loading || (!natureData.loading && !natureData.data.length),
          no_data: !natureData.loading && !natureData.data.length,
        })}
      >
        {natureData.loading ? (
          <Preloader centered loading static />
        ) : (
          <>
            <div className={Styles['nature-business-lists']}>
              {!natureData.data.length ? (
                <div className={Styles['nature-business-no-data']}>
                  <div className={Styles['nature-business-no-data-text']}>
                    No data currently available.
                  </div>
                </div>
              ) : (
                <>
                  {natureData.data.map((obj) => (
                    <Link
                      key={obj.code}
                      className={Styles['nature-business-list']}
                      to={`${UK_PRIVATE_COMPANY_INSIGHTS_PATH}/nature-of-business/${obj.code}-${obj.name?.replace(/[^a-zA-Z0-9 ]/g, '')?.replaceAll(' ', '-')}`}
                    >
                      <div className={Styles['nature-business-list-title']}>
                        {obj.name}
                      </div>
                      <div className={Styles['nature-business-list-value']}>
                        {(obj.percentageFromTotal || 0).toFixed(2)}
                        %
                      </div>
                    </Link>
                  ))}
                </>
              )}
            </div>
            <div className={Styles['nature-business-see-more']}>
              {!!natureData.data.length && (
                <Link
                  to={`${UK_PRIVATE_COMPANY_INSIGHTS_PATH}/nature-of-business-sectors`}
                >
                  See More
                  <FontAwesomeIcon icon={faChevronRight} />
                </Link>
              )}
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default NatureBusinessSectors;
